import { useQuery } from '@tanstack/react-query';
import { fetchPSLList } from '@views/screens/common/data-provider/psl-list';

export const useGetPSLList = () => {
  return useQuery({
    queryKey: ['psl-list'],
    queryFn: () => fetchPSLList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
